import { api } from "./http";

export const aiApi = {
  genTranslateText: (param) => api.post("/api/AI/gemini", param),
  genTranslateTextOpenAi: (param) => api.post("/api/AI/gpt", param),
  genText2Image: (param) => api.post("/api/AI/text2image", param),
};
